import {ZIDX} from "../../standalone/standaloneLibrary.js";
import {ZIDXRAGChat} from "../../standalone/ai/RAGChat.js";

/**
 * Super admin only chatbot page, served on the account host at /internal-chat/?ai_bot_id=N (see InternalChatGateway.java).
 * The server renders the same markup as /chat/ (zidxRAGChatContainer), so the RAG chat code does all the work:
 * session creation, streaming from /rag-chat-stream/ and the optional search results panel.
 */
export class ZIDXInternalChat extends ZIDXRAGChat {
    constructor(zidx: ZIDX) {
        super(zidx);
    }
}
